const LegalFooter = () => (
  <div className="legal-footer">
    <div className="legal-footer-wrapper">
      <p>
        Photos and videos are either the property of Syngenta or are used with 
        permission.
      </p>
      <p>
        &copy; {new Date().getFullYear()} Syngenta.{" "}
        <span className="bold">
          Important: always read and follow label instructions. Some products
          may not be registered for sale or use in all states or counties and/or
          may have state-specific use requirements. Please check with your local
          extension service to ensure registration and proper use.
        </span>{" "}
        The trademarks displayed or otherwise used herein are trademarks of a
        Syngenta Group Company. All other trademarks are the property of their
        respective owners.
      </p>
    </div>
  </div>
);

export default LegalFooter;